import axios from 'axios'
import config from './config'
import store from '../store'
import hui from 'h_ui/dist/h_ui.min.js'
import { goLogin } from '@/utils'
import Vue from 'vue'
const httpFetch = axios.create({
  ...config,
  baseURL:window.LOCAL_CONFIG.API_HOME_U,
})
// request拦截器
httpFetch.interceptors.request.use(
  config => {
    config.headers['Access-Token'] = window.sessionStorage.getItem('Access-Token')
      ? window.sessionStorage.getItem('Access-Token') : ''
    config.headers['X-Uplus-System'] = 1
    config.timeout = 20000
    config.data = config.data ? config.data : {}
    return config
  },
  error => {
    //console.log(error)
    return Promise.reject(error)
  }
)
httpFetch.interceptors.response.use(
  response => {
    const errorNo = response.data.code || response.data.error_no
    switch (errorNo) {
      case -1044:
        // hui.hMessage.error('未认证用户，请重新登录')
        goLogin()
        break
      case -1040:
        // store.state.mutations.loginType = false // 登录状态
        // hui.hMessage.error('登录超时，请重新登录')
        goLogin()
        break
      case -1005:
        // hui.hMessage.error('非法令牌，请重新登录')
        goLogin()
        break
      case -31202: case -31203:
        // 知识库接口会话失效处理
        fnWinLocaltion()
        break
      default:
        // 同一浏览器，登录两个账号时，发请求时浏览器所带cookie是后一个登录账户的信息，如果前一个账户发请求，需要把权限数据更新为最新
        let user = JSON.parse(window.localStorage.getItem('user'))
        if (user) {
          store.commit('userName', user.name)
          store.commit('userTopic', user.head)
        }
        return response.data
    }
  },
  error => {
    return Promise.reject(error)
  }
)
function fnWinLocaltion () {
  // 访问三方登录获取 ticket, 重定向获取 cookie，再次重定向目标页面
  // 本地运行项目时，页面地址为localhost，无法正常跳回当前页面
  // 本地连调只能使用固定测试环境路径
  let pageUrl = window.location.href
  const pageOrigin = common.GetPageOrigin()
  if (pageOrigin.indexOf('http://localhost') === 0) {
    pageUrl = pageUrl.replace(pageOrigin, 'https://service.uat.hs-uplus.cn')
  }
  const knowledgeTicketUrl = `${window.soConfig.knowledgeServerUrl}/kb/ticketverification?service=${encodeURIComponent(pageUrl)}`
  const jumpUrl = `${defaultIP}/thridLoginAuthentication.json?service=${encodeURIComponent(knowledgeTicketUrl)}`
  window.location.href = jumpUrl
}
function checkStatus(status) {
  let errorInfo = ''
  switch (status) {
    case -1:
      errorInfo = '远程服务响应失败,请稍后重试'
      break
    case 500:
      errorInfo = '500：访问服务失败'
      break
    case 403:
      errorInfo = '请不要输入非法字符！'
      break
    case 404:
      errorInfo = '404：资源不存在'
      break
  }
  hui.hMessage.error(errorInfo)
}
function checkUserState(errorCode, errorInfo) {
  if (errorCode == '100002') {
    // 未登录就跳转登录
    Vue.prototype.$goLoginUrl()
    return;
  }
  const stateMap = new Map([
    ['120002', '对不起，该服务仅限实名认证的用户购买,请前往实名认证'],
    ['120003', '对不起，该服务仅限实名认证的用户购买,请查看实名审核'],
    ['120004', '对不起，该服务仅限实名认证的企业用户购买,请前往实名认证'],
  ]);
  if (stateMap.has(errorCode)) {
    let content = stateMap.get(errorCode)
    hui.hMsgBox.confirm({
      title: '实名提示',
      content: content,
      onOk: () => {
        window.location.href = '/cloud-console/account/authentication'
      },
      onCancel: () => { }
    })
  } else {
    hui.hMessage.info(errorInfo)
  }
}
export default httpFetch



// WEBPACK FOOTER //
// ./src/gtn/api/httpFetchUPlus.js